var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContract(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66658 8H7.33325V9H2.66658V8ZM2.66658 6H9.33325V7H2.66658V6ZM2.66658 4H9.33325V5H2.66658V4ZM10.6666 1.3H7.87991C7.59991 0.546 6.86658 0 5.99991 0C5.13325 0 4.39991 0.546 4.11991 1.3H1.33325C1.23991 1.3 1.15325 1.3065 1.06658 1.326C0.806581 1.378 0.573248 1.508 0.393248 1.6835C0.273248 1.8005 0.173248 1.9435 0.106581 2.0995C0.0399146 2.249 -8.55057e-05 2.418 -8.55057e-05 2.6L-0.000103921 10.7025C-0.000103921 10.878 -0.0267702 11.0705 0.0398965 11.2265C0.106563 11.3825 0.206563 11.519 0.326563 11.6425C0.506563 11.818 0.739896 11.948 0.999896 12C1.08656 12.013 1.40658 12 1.49991 12L10.6666 11.9928C11.3999 11.9928 11.9999 11.4078 11.9999 10.6928V2.6C11.9999 1.885 11.3999 1.3 10.6666 1.3ZM5.99991 0.525C6.27325 0.525 6.49991 0.746 6.49991 1.0125C6.49991 1.279 6.27325 1.5 5.99991 1.5C5.72658 1.5 5.49991 1.279 5.49991 1.0125C5.49991 0.746 5.72658 0.525 5.99991 0.525Z",
    fill: "#5B79B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.da882d28.svg";
export { ForwardRef as ReactComponent };